import { finalize, Observable } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../services/session-storage.service';
import { SpinnerService } from '../services/spinner.service';

export const appHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(SpinnerService);
  spinnerService.status$.set(true);
  const request = req.clone({
    setHeaders: {
      Authorization: `Bearer ${sessionStorage.getItem('token') ?? ""}`
    },
    withCredentials: true
  });
  return next(request)
    .pipe(finalize(() => spinnerService.status$.set(false)));
};

/**
 * @deprecated Use appHttpInterceptor HttpInterceptorFn instead
 */
@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(
    private sessionStorageService: SessionStorageService,
    private spinnerService: SpinnerService
  ) {}

  private counter = 0;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.spinnerService.isIgnoredEndpoint(request.url)) {
      this.spinnerService.show();
    }
    this.counter++;

    const token = this.sessionStorageService.get('token');

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true
    });

    return next.handle(request)
      .pipe(
        finalize(() => {
          this.counter--;
          if (this.counter === 0) {
            this.spinnerService.hide();
          }
        })
      );
  }

}
